import { defineMessages } from 'react-intl';

export default defineMessages({
  firstNameLabel: {
    id: 'forms.AddressForm.firstNameLabel',
    description: 'First name label',
    defaultMessage: 'First Name*',
  },
  lastNameLabel: {
    id: 'forms.AddressForm.lastNameLabel',
    description: 'Last name label',
    defaultMessage: 'Last Name*',
  },
  streetAddressLabel: {
    id: 'forms.AddressForm.streetAddressLabel',
    description: 'Street address label',
    defaultMessage: 'Street Address*',
  },
  apartmentLabel: {
    id: 'forms.AddressForm.apartmentLabel',
    description: 'Apartment label',
    defaultMessage: 'Apartment Number, Unit, Floor (optional)',
  },
  zipCodeLabel: {
    id: 'forms.AddressForm.zipCodeLabel',
    description: 'Zip code label',
    defaultMessage: 'Zip Code*',
  },
  cityLabel: {
    id: 'forms.AddressForm.cityLabel',
    description: 'City label',
    defaultMessage: 'City*',
  },
  countryLabel: {
    id: 'forms.AddressForm.countryLabel',
    description: 'Country label',
    defaultMessage: 'Country*',
  },
  stateLabel: {
    id: 'forms.AddressForm.state',
    description: 'State label',
    defaultMessage: 'State*',
  },
  emailLabel: {
    id: 'forms.AddressForm.emailLabel',
    description: 'Email label',
    defaultMessage: 'Email Address*',
  },
  phoneLabel: {
    id: 'forms.AddressForm.phoneLabel',
    description: 'Phone label',
    defaultMessage: 'Phone Number*',
  },
});
